import axios from "axios";

export const SendOTP = async (contact) => {
  try {
    const otpData = { contact };
    const url = "/api/sentotp";

    const { data } = await axios.post(url, otpData);
    return data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};